export default "__VITE_ASSET__Tk3cKcIR8tYJqQz5l73v2A__"